var _path, _circle, _path2, _path3, _path4, _path5, _polygon, _polygon2, _rect, _rect2, _polygon3, _polygon4, _rect3, _rect4, _polygon5, _polygon6, _rect5, _rect6, _polygon7, _polygon8, _rect7, _rect8, _polygon9, _polygon10, _rect9, _rect10, _polygon11, _polygon12, _rect11, _rect12, _polygon13, _polygon14, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path6, _path7, _rect21, _path8, _path9, _path10, _path11, _rect22, _path12, _polygon15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHdb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "afdfd1e9-9b52-4ce3-aad9-0a68bb11f588",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 1137 693.11183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coming home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.89819,796.55591l-1.95117-.43945c21.75586-96.751,76.43018-184.60937,153.95117-247.3916A444.114,444.114,0,0,1,1033.053,794.9358l-1.94922.44336C985.05005,593.17017,807.82935,451.94459,600.134,451.94459,395.1604,451.94459,213.79956,596.87427,168.89819,796.55591Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 417.13335,
    cy: 69.40326,
    r: 54.31516,
    fill: "#ff6584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.63058,784.217c1.694,6.26185,7.4961,10.14,7.4961,10.14s3.05572-6.27434,1.36177-12.53619-7.49609-10.14-7.49609-10.14S212.93664,777.95518,214.63058,784.217Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.11972,782.87129c4.64821,4.52485,5.216,11.48059,5.216,11.48059s-6.9685-.38048-11.61672-4.90533-5.216-11.4806-5.216-11.4806S212.4715,778.34644,217.11972,782.87129Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#fbe1e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.63058,784.217c1.69395,6.26185,7.4961,10.14,7.4961,10.14s3.05572-6.27434,1.36177-12.53619-7.49609-10.14-7.49609-10.14S341.93664,777.95518,343.63058,784.217Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M346.11972,782.87129c4.64821,4.52485,5.216,11.48059,5.216,11.48059s-6.9685-.38048-11.61672-4.90533-5.216-11.4806-5.216-11.4806S341.4715,778.34644,346.11972,782.87129Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#fbe1e5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "337.71 181.988 317.286 165.648 431.66 63.529 721.679 63.529 721.679 153.394 533.779 280.022 337.71 181.988",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "774.556 120.812 774.556 65.569 736.05 65.569 736.05 79.098 721.679 63.529 627.729 165.648 590.966 190.157 533.964 606.62 619.93 692.585 819.714 692.585 819.714 169.733 774.556 120.812",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 317.28615,
    y: 165.64842,
    width: 310.44316,
    height: 526.93642,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 437.78711,
    y: 563.91431,
    width: 57.1869,
    height: 128.67052,
    fill: "#ccc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "376.515 600.677 376.515 580.253 352.007 580.253 352.007 600.677 374.473 600.677 376.515 600.677",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.473 617.016 352.007 617.016 352.007 637.44 376.515 637.44 376.515 617.016 374.473 617.016",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 392.85455,
    y: 580.25343,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 392.85455,
    y: 617.01643,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.991 600.677 543.991 580.253 519.483 580.253 519.483 600.677 541.949 600.677 543.991 600.677",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "541.949 617.016 519.483 617.016 519.483 637.44 543.991 637.44 543.991 617.016 541.949 617.016",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 560.33046,
    y: 580.25343,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 560.33046,
    y: 617.01643,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "715.552 192.199 715.552 171.776 691.043 171.776 691.043 192.199 713.51 192.199 715.552 192.199",
    fill: "#3f3d56"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "713.51 208.539 691.043 208.539 691.043 228.962 715.552 228.962 715.552 208.539 713.51 208.539",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 731.89116,
    y: 171.77558,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 731.89116,
    y: 208.53859,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "715.552 306.573 715.552 286.149 691.043 286.149 691.043 306.573 713.51 306.573 715.552 306.573",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "713.51 322.912 691.043 322.912 691.043 343.336 715.552 343.336 715.552 322.912 713.51 322.912",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 731.89116,
    y: 286.14938,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 731.89116,
    y: 322.91238,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "715.552 420.947 715.552 400.523 691.043 400.523 691.043 420.947 713.51 420.947 715.552 420.947",
    fill: "#3f3d56"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "713.51 437.286 691.043 437.286 691.043 457.71 715.552 457.71 715.552 437.286 713.51 437.286",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 731.89116,
    y: 400.52318,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 731.89116,
    y: 437.28618,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "715.552 535.321 715.552 514.897 691.043 514.897 691.043 535.321 713.51 535.321 715.552 535.321",
    fill: "#3f3d56"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "713.51 551.66 691.043 551.66 691.043 572.084 715.552 572.084 715.552 551.66 713.51 551.66",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 731.89116,
    y: 514.89697,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 731.89116,
    y: 551.65998,
    width: 24.50867,
    height: 20.42389,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 352.00676,
    y: 192.19947,
    width: 236.91715,
    height: 49.01734,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 352.00676,
    y: 290.23416,
    width: 236.91715,
    height: 49.01734,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 352.00676,
    y: 388.26884,
    width: 236.91715,
    height: 49.01734,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 352.00676,
    y: 486.30352,
    width: 236.91715,
    height: 49.01734,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    y: 690.52882,
    width: 1137,
    height: 2,
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 190.4049,
    y: 459.61475,
    width: 5.87477,
    height: 232.05349,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M281.99715,592.63138c.374,81.14332-56.71464,147.18749-56.71464,147.18749s-57.695-65.51515-58.06894-146.65847,56.71464-147.18749,56.71464-147.18749S281.62317,511.48806,281.99715,592.63138Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#fbe1e5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.99715,592.63138c.374,81.14332-56.71464,147.18749-56.71464,147.18749s-57.695-65.51515-58.06894-146.65847,56.71464-147.18749,56.71464-147.18749S281.62317,511.48806,281.99715,592.63138Z",
    transform: "translate(-31.5 -103.44409)",
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 114.03286,
    y: 459.61475,
    width: 5.87477,
    height: 232.05349,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.62511,592.63138c.374,81.14332-56.71464,147.18749-56.71464,147.18749s-57.695-65.51515-58.06894-146.65847,56.71465-147.18749,56.71465-147.18749S205.25114,511.48806,205.62511,592.63138Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#fbe1e5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M977.0545,268.76437c-46.27672.21329-83.94415.897-83.94415.897s44.77365-59.30728,83.77623-37.33436,83.80663,36.56195,83.80663,36.56195S1023.33123,268.55108,977.0545,268.76437Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.0545,382.76437c-46.27672.21329-83.94415.897-83.94415.897s44.77365-59.30728,83.77623-37.33436,83.80663,36.562,83.80663,36.562S252.33123,382.55108,206.0545,382.76437Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#f2f2f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M374.0545,144.76437c-46.27672.21329-83.94415.897-83.94415.897s44.77365-59.30728,83.77623-37.33436,83.80663,36.562,83.80663,36.562S420.33123,144.55108,374.0545,144.76437Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#f2f2f2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1035.03286,
    y: 459.61475,
    width: 5.87477,
    height: 232.05349,
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.62511,592.63138c.374,81.14332-56.71464,147.18749-56.71464,147.18749s-57.695-65.51515-58.06894-146.65847,56.71465-147.18749,56.71465-147.18749S1126.25114,511.48806,1126.62511,592.63138Z",
    transform: "translate(-31.5 -103.44409)",
    fill: "#fbe1e5"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "824.667 547.629 883.956 547.629 883.956 533.318 916.667 533.318 916.667 547.629 978 547.629 978 611.007 916.667 611.007 916.667 690.74 883.956 690.74 883.956 611.007 824.667 611.007 794 576.251 824.667 547.629",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdb);
export default __webpack_public_path__ + "static/media/hdb.d100cf93fe389da2bf9954176cf37af5.svg";
export { ForwardRef as ReactComponent };